import React from 'react';
import { cn } from 'utils';

export function VideoLabel(props: {
  isSelected?: boolean;
  text: string;
}): React.ReactElement {
  const { text, isSelected } = props;
  return (
    <strong
      className={cn(
        'odin-absolute',
        'odin-z-10',
        'odin-border',
        'odin-border-2',
        'odin-font-normal',
        'odin-inset-1',
        'odin-px-2',
        'odin-py-1',
        'odin-rounded-md',
        'odin-text-left',
        'odin-text-odin-white',
        'odin-uppercase',
        isSelected ? 'odin-border-odin-white' : 'odin-border-transparent',
      )}
    >
      {text}
    </strong>
  );
}
